import { BehaviorSubject, Observable } from 'rxjs';

declare let alertify: any;
export class GlobalActions {
    private static spinnerIsVisible: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public static get InfiniteInterval(): number {
        return 0x1 << 30;
    }
    public static get SpinnerIsVisible(): Observable<boolean> {
        return GlobalActions.spinnerIsVisible;
    }
    public static showSpinner(): void {
        GlobalActions.spinnerIsVisible.next(true);
    }

    public static hideSpinner(): void {
        GlobalActions.spinnerIsVisible.next(false);
    }
    public static displayWarning(message: string, delay: number = 5000): void {
        const warningTemplate = `
        <div class="alertify-inner">
            <div class="alertify-img">
                <svg class="icon icon-20-status-warning icon-notification-warn">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/s7-icons-20.svg#status-warning"></use>
                </svg>
            </div>
            <div class="alertify-msg">${message}</div>
        </div>`;

        alertify.log(warningTemplate, 'warning', delay);
    }
    public static displaySuccess(message: string, delay: number = 5000): void {
        const successTemplate = `
        <div class="alertify-inner">
            <div class="alertify-img">
                <svg class="icon icon-20-status-ok icon-notification-success">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/s7-icons-20.svg#status-ok"></use>
                </svg>
            </div>
            <div class="alertify-msg">${message}</div>
        </div>`;

        alertify.success(successTemplate, delay);
    }

    public static displayError(message: string, delay: number = 5000): void {
        const errorTemplate = `
        <div class="alertify-inner">
            <div class="alertify-img">
                <svg class="icon icon-20-status-error icon-notification-error">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/s7-icons-20.svg#status-error"></use>
                </svg>
            </div>
            <div class="alertify-msg">${message}</div>
        </div>`;

        alertify.error(errorTemplate, delay);
    }

    public static displayAlert(message: string, okClick?: () => void): void {
        alertify.alert(message, okClick);
    }

    public static displayPrompt(message: string, okClick: (value: string) => void, cancelClick: () => void, defaultValue: string): void {
        const clickCallback = (result: boolean, value: string | null) => {
            if (result) {
                okClick(value);
            } else {
                cancelClick();
            }
        };
        alertify.prompt(message, clickCallback, defaultValue);
    }

    public static displayConfirm(message: string, okCallback: () => void, cancelCallback?: () => void): void {
        alertify.confirm(message, (result: boolean) => {
            if (result) {
                okCallback();
            } else if (cancelCallback) {
                cancelCallback();
            }
        });
    }
}
